import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { formatBoolean, formatCurrency } from "../../utils/formatters";
import { ManagementData } from "../../Typings/dataListing";
import { AppDispatch } from "../../redux/store";
import { getManagementById } from "../../redux/actions/managementAction";

const ManagementView: FC = () => {
  const { mgtid } = useParams<{ mgtid: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const [managementData, setManagementData] = useState<ManagementData | null>(
    null
  );
  const { permissions } = usePermissions();
  const roleid = localStorage.getItem("roleid") ?? "";

  useEffect(() => {
    getManagementData();
  }, [dispatch]);

  const getManagementData = async () => {
    if (mgtid) {
      const payload = { mgtid: parseInt(mgtid, 10) };
      try {
        dispatch(
          getManagementById(payload, (response: any) => {
            const managementData = response?.data;
            if (managementData) {
              setManagementData(managementData);
            }
          })
        );
      } catch (error) {
        console.error("Error fetching management details:", error);
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">F2F Management</span>
              {managementData?.market_name || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Market Name
                <span className="d-block pt-1">
                  {managementData?.market_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile Name
                <span className="d-block pt-1">
                  {managementData?.profile_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile ID
                <span className="d-block pt-1">
                  {managementData?.profile_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Management ID
                <span className="d-block pt-1">
                  {managementData?.mgtid || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Number of Staff
                <span className="d-block pt-1">
                  {managementData?.num_staff || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Positions
                <span className="d-block pt-1">
                  {managementData?.positions || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Staff
                <span className="d-block pt-1">
                  {managementData?.other || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Average Unpaid Market Staff
                <span className="d-block pt-1">
                  {managementData?.ave_unpaid_market || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Average Unpaid Non-Market Staff
                <span className="d-block pt-1">
                  {managementData?.ave_unpaid_non_market || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Average Paid Market Staff
                <span className="d-block pt-1">
                  {managementData?.ave_paid_market || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Average Paid Non-Market Staff
                <span className="d-block pt-1">
                  {managementData?.ave_paid_non_market || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Annual Staff Budget
                <span className="d-block pt-1">
                  {formatCurrency(managementData?.annual_budget_for_staff)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Annual Operating Budget
                <span className="d-block pt-1">
                  {managementData?.annual_operating_budget || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Bookkeeper
                <span className="d-block pt-1">
                  {managementData?.bookkeeper || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Annual Application Fee
                <span className="d-block pt-1">
                  {formatCurrency(managementData?.annual_application_fee)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Annual Membership Fee
                <span className="d-block pt-1">
                  {formatCurrency(managementData?.annual_membership_fee)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Percentage Sales
                <span className="d-block pt-1">
                  {managementData?.percentage_sales}%
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                No Charge
                <span className="d-block pt-1">
                  {managementData?.no_charge}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4">
                Other Charge
                <span className="d-block pt-1">
                  {managementData?.other_charge || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4">
                Other Charge Explained
                <span className="d-block pt-1">
                  {managementData?.other_charge_explained || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Average Number of Vendors
                <span className="d-block pt-1">
                  {managementData?.ave_num_vendors || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Full-time Year-round Manager (Paid)
                <span className="d-block pt-1">
                  {formatBoolean(managementData?.role_manager_ft_year_paid)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Full-time Year-round Manager (Unpaid)
                <span className="d-block pt-1">
                  {formatBoolean(managementData?.role_manager_ft_year_unpaid)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Part-time Year-round Manager (Paid)
                <span className="d-block pt-1">
                  {formatBoolean(managementData?.role_manager_pt_year_paid)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Part-time Year-round Manager (Unpaid)
                <span className="d-block pt-1">
                  {formatBoolean(managementData?.role_manager_pt_year_unpaid)}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4">
                Other Rules
                <span className="d-block pt-1">
                  {managementData?.other_rules || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4">
                Other Rules Path
                <span className="d-block pt-1">
                  {managementData?.other_rules_path || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Full-time Hourly Rate
                <span className="d-block pt-1">
                  {managementData?.hourly_rate_full_time}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Part-time Hourly Rate
                <span className="d-block pt-1">
                  {managementData?.hourly_rate_part_time}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              {permissions && roleid && (
                <NavLink to="/Management">
                  <button type="button" className="formBtn cancel">
                    Back to List
                  </button>
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};
export default ManagementView;
